import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'


const Sponsor = ({ data: { title, sponsor: { name, desc} } }) => (
  <StaticQuery
    query={graphql`
      query {
        liferay: file(relativePath: {eq: "contents/loghi_IID_liferay.jpg"}){
          childImageSharp{
            fluid(maxWidth: 400){
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={staticData => {
      return (
        <section id="sponsor" className="section sponsor text-center" aria-labelledby="region-sponsor">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1">
                <h1 id="region-sponsor" className="section__title">{title}</h1>
                <div className="row">
                  <div className="col-sm-4 col-md-offset-4">
                    <a href="https://www.liferay.com/it/home" title={name} target="_blank" rel="noopener noreferrer" className="sponsor__logo text-center">
                      <Img fluid={staticData.liferay.childImageSharp.fluid} alt={name} className="sponsor__img" />
                      <span className="sponsor__name">{name}</span>
                      <span className="sponsor__desc">{desc}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
);

export default Sponsor;
